import { Edit, Trash, LogOut, Users } from "lucide-react"
import { useTranslation } from "react-i18next"

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@f2e/ui/components/base"
import { cn } from "@f2e/ui/lib/utils"

import { PermissionMenuItem } from "@/components/Auth"
import { Workspace, Permission } from "@/types"
import { isOwner } from "@/lib/utils"

export interface ActionButtonProps {
  className?: string
  workspace: Workspace
  onEdit?: (event: React.MouseEvent) => void
  onDelete?: (event: React.MouseEvent) => void
  onLeave?: (event: React.MouseEvent) => void
  onSetDefault?: (event: React.MouseEvent) => void
  onMembers?: (event: React.MouseEvent) => void
}

const ActionButton = ({
  className,
  workspace,
  onEdit,
  onDelete,
  onLeave,
  onMembers,
}: ActionButtonProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={cn("flex flex-col", className)}
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownMenuItem onClick={onMembers}>
        <Users className="w-4 h-4 mr-2" />
        {t("workspace.detail.tabs.members")}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <PermissionMenuItem
        permission={Permission.WsChangeName}
        workspace={workspace}
        disabledTooltip={t("common.noPermission")}
        onClick={onEdit}
      >
        <Edit className="w-4 h-4 mr-2" />
        {t("workspace.edit")}
      </PermissionMenuItem>
      <DropdownMenuSeparator />
      <PermissionMenuItem
        permission={Permission.WsDelete}
        workspace={workspace}
        disabledTooltip={t("common.noPermission")}
        variant="destructive"
        onClick={onDelete}
      >
        <Trash className="w-4 h-4 mr-2" />
        {t("workspace.delete")}
      </PermissionMenuItem>
      {workspace.isJoined && !isOwner(workspace.myRole) && (
        <DropdownMenuItem onClick={onLeave}>
          <LogOut className="w-4 h-4 mr-2" />
          {t("workspace.leave")}
        </DropdownMenuItem>
      )}
    </div>
  )
}

export { ActionButton }
export default ActionButton
